import FetchFactory from '../factory';

export type ShippingMethod = {
  Name: string;
  ShippingText: string;
  ShippingFee: string;
  ServicePoints: ShippingLockers[];
  ShippingMethodSystemName: string;
  IconUrl: string;
};

export type ShippingLockers = {
  Id: string;
  Name: string;
  Selected: boolean;
  Description: string;
  Time: string;
  Address?: {
    City: string;
    Street: string;
    Zip: string;
    Country: string;
  };
};

export const POSTNORD_SYSTEM_NAME = 'Shipping.Electra.Posten';
export const INSTABOX_SYSTEM_NAME = 'Shipping.Electra.Instabox';

const CONTROLLER_PATH = '/api-electra/ShippingMethod/';

class shippingMethodModule extends FetchFactory<any> {
  /**
   * Return the products as array
   * @param asyncDataOptions options for `useAsyncData`
   * @returns
   */
  async getShippingMethods(): Promise<ShippingMethod[]> {
    return await this.get(`${CONTROLLER_PATH}GetShippingMethod`);
  }

  async setShippingMethod(
    ShippingMethodSystemName: string,
    ServicePointId: string,
  ) {
    const url = `${CONTROLLER_PATH}SetShippingMethod`;
    return await this.call('POST', url, {
      shippingMethodSystemName: ShippingMethodSystemName,
      servicePointId: ServicePointId,
    });
  }
}

export default shippingMethodModule;
